import { ActionHandlerMap, IAction, IMap } from '../types/common'

export const createActionHandler = (actionHandlerMap: ActionHandlerMap<{}, IAction>, initialStore = {}) => (
  state: {} = initialStore,
  action: IAction
) => {
  const reducer = Object.values(actionHandlerMap).find(it => it.filter(action))
  return (reducer && reducer.reduce(state, action as any)) || state
}

/**
 * It merges map up to 1 level deep(implying that the key is id and the value is flat)
 * @param map
 * @param map2
 */

export const mergeMap = <T extends object>(map: IMap<T> = {}, map2: IMap<T> = {}): IMap<T> => {
  const idsToMerge = Object.keys(map2).filter(it => map.hasOwnProperty(it))
  return {
    ...map,
    ...map2,
    ...idsToMerge.reduce((mergedMap, id) => {
      mergedMap[id] = { ...(map[id] as object), ...(map2[id] as object) }
      return mergedMap
    }, {})
  }
}

/**
 * It removes a property from the object by key
 * Returns an object without this value
 * @param map
 * @param id
 */
export const removeById = <T extends {}>(map: T, id: string): T => {
  delete map[id]
  return map as T
}



// WEBPACK FOOTER //
// ./src/utils/state.ts